// extracted by mini-css-extract-plugin
module.exports = {"popular-categories-section":"PopularCategories_popular-categories-section__2MhYg"};